<template>
  <div class="app-container">

    <div class="box">

      <div class="filter-container">
        <el-button type="primary" class="butT" @click="handleCreate()" >增加</el-button>
      </div>

      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="50px"></el-table-column>
        <el-table-column prop="shopname" label="广告名" align="center"></el-table-column>
        <el-table-column prop="shoplink" label="链接" align="center"></el-table-column>
        <el-table-column prop="imagearr" label="图片名称" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <el-table-column label="编辑" align="center" width="80px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
        <el-table-column label="删除" align="center" width="80px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>

        <el-table-column label="禁用启用" align="center" width="50px">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                @change = handleopenorclose(scope.row)
                :active-value = "1"
                :inactive-value = "0"
                active-color="#13ce66"
                inactive-color="#ff4949"
            >
            </el-switch>

          </template>

        </el-table-column>

      </el-table>

      <!--分页组件-->
      <div class="pagination-container">

        <el-pagination
            class="pagiantion"

            @current-change="handleCurrentChange"

            :current-page="pagination.currentPage"

            :page-size="pagination.pageSize"

            layout="total, prev, pager, next, jumper"

            :total="pagination.total">

        </el-pagination>

      </div>

       <!-- 新增标签弹层 -->
       <div>
        <el-dialog title="新增商品" :visible.sync="AddialogFormVisible">
          <el-form :model="formData" label-position="right" label-width="100px">

            <el-form-item label="名称">
              <el-input v-model="formData.shopname" autocomplete="off" placeholder="名称"></el-input>
            </el-form-item>

            <el-form-item label="链接" >
              <el-input v-model="formData.shoplink" autocomplete="off" placeholder="链接"></el-input>
            </el-form-item>

            <el-form-item label="状态" >
              <el-input v-model="formData.status" autocomplete="off" placeholder="0为禁用 1为启用 "></el-input>
            </el-form-item>

            <el-form-item label="类型">
              <el-input v-model="formData.type" autocomplete="off" placeholder="0为商品 1为帮助 "></el-input>
            </el-form-item>

            <el-form-item label="上传图片">
              <div class="divupload">
                <el-upload
                    class="upload-demo"
                    ref='uploadfiles'
                    :file-list="imageList"
                    drag
                    action="#"
                    :http-request="handleChange"
                >
                  <img
                      v-if="imageUrl"
                      :src="imageUrl"
                      style="max-width: 100%; max-height: 100%"
                      class="avatar"
                  ></img>
                  <i
                      v-else
                      class="el-icon-upload"
                  ></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </div>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click= "cancel()">取 消</el-button>
            <el-button type="primary" @click= "upload()">确 定</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 编辑弹层 -->
      <div class="add-form">
          <el-dialog title="编辑" :visible.sync="AdupdatadialogFormVisible">
            <el-form ref="dataEditForm" :model="updateform"  label-position="right" label-width="100px" >
              <el-row>
                <el-col :span="15">
                  <el-form-item label="名称" prop="shopname">
                    <el-input v-model="updateform.shopname" ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="15">
                  <el-form-item label="链接" prop="shoplink">
                    <el-input v-model="updateform.shoplink"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="15">
                  <el-form-item label="状态" prop="status">
                    <el-input v-model="updateform.status"/>
                  </el-form-item>
                </el-col>
              </el-row>

            <el-form-item label="类型">
                <el-input v-model="updateform.type" autocomplete="off" ></el-input>
            </el-form-item>

              <el-row>
                <el-form-item label="上传图片">
                  <div class="divupload">
                    <el-upload
                        class="upload-demo"
                        ref='uploadfiles'
                        :file-list="imageList"
                        drag
                        action="#"
                        :http-request="handleChange"
                    >
                      <img
                          v-if="imageUrl"
                          :src="imageUrl"
                          style="max-width: 100%; max-height: 100%"
                          class="avatar"
                      ></img>
                      <i
                          v-else
                          class="el-icon-upload"
                      ></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">

              <el-button @click="cancel()">取消</el-button>

              <el-button type="primary" @click="update()">确定</el-button>

            </div>

          </el-dialog>
        </div>

    </div>
  </div>

</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      dataList: [],//当前页要展示的列表数据
      imageList: [],
      imageList1:[],
      AddialogFormVisible:false,
      AdupdatadialogFormVisible:false,
      pagination: {//分页相关模型数据
        currentPage: 1,//当前页码
        pageSize:10,//每页显示的记录数
        total:0,//总记录数
        username:""
      },
      imageUrl:'',
      updateform: {
      },
      formData: {
      },
    }
  },
  created() {
    this.getadlist()
  },

  methods: {
    handleChange(param){
      const data = new FormData();
      data.append('file', param.file);
      axios.post('/shop/uploadv2', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(res => {
        this.formData.imagearr = res.data.data;
        this.updateform.imagearr = res.data.data;
        this.imageUrl = "http://api.gw.duhongtech.com/sight/shop/download?name="+res.data.data
      }).catch(err => {
        console.log(err);
      });
    },
    upload(){
      axios({
        method:"post",
        url:"/shop/save",
        data:this.formData
      }).then(res=>{
        this.$message.success(res.data.msg);
        this.AddialogFormVisible = false;
        this.getadlist();
        this.$refs.uploadfiles.clearFiles();
        this.imageUrl = "";
      })
    },

    //弹出添加窗口
    handleCreate() {
      this.AddialogFormVisible = true;
      this.resetForm();
    },

    //重置表单
    resetForm() {
      this.formData = {};
    },

    //取消
    cancel(){
      this.AdupdatadialogFormVisible = false;
      this.AddialogFormVisible = false;
      this.$refs.uploadfiles.clearFiles();
      this.$message.info("当前操作取消");
      this.imageUrl = "";
    },

    getadlist(){
      axios({
        method:"post",
        url:"/shop/page",
        data:{
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          username: this.pagination.username
        }
      }).then(res=>{
        this.pagination.pageSize = res.data.data.size;
        this.pagination.currentPage = res.data.data.current;
        this.pagination.total = res.data.data.total;
        this.dataList = res.data.data.records
        console.log(this.dataList[0].status);

        // console.log("----------------------------------------------")
        // console.log(res.data.data.records)
      })
    },
    //切换页码
    handleCurrentChange(currentPage) {
      //修改页码值为当前选中的页码值
      this.pagination.currentPage = currentPage;
      //执行查询
      this.getadlist();
    },


    //取消
    cancel(){
      this.$message.info("当前操作取消");
    },

    //弹出编辑窗口
    handleUpdate(row) {
      this.updateform = JSON.parse(JSON.stringify(row));
      this.imageUrl = "http://api.gw.duhongtech.com/sight/shop/download?name="+this.updateform.imagearr;
      this.AdupdatadialogFormVisible = true;
      this.$refs.uploadfiles.clearFiles();
    },
    //修改
    update() {
      axios.put("/shop/updatead",this.updateform).then((res)=>{
        //判断当前操作是否成功
        this.AdupdatadialogFormVisible = false;
        this.$message.success("修改成功");
      }).finally(()=>{
        //2.重新加载数据
        this.getadlist();
        this.imageUrl = "";
      });
    },

    // 删除
    handleDelete(row) {
      // console.log(row);
      this.$confirm("此操作永久删除当前信息，是否继续？","提示",{type:"info"}).then(()=>{
        axios.delete("/shop/deletead/"+row.id).then((res)=>{
            this.$message.success("删除成功");
        }).finally(()=>{
          //2.重新加载数据
          this.getadlist();
        });
      }).catch(()=>{
        this.$message.info("取消操作");
      });
    },



    //禁用启用用户
    handleopenorclose(row){
      console.log(row)
      this.updateform = row;
      console.log(this.updateform.status)
      axios.put("/shop/updatead",this.updateform).then((res)=>{
        this.$message.success("修改成功");
      }).finally(()=>{
        //2.重新加载数据
        this.getadlist();
      });
    },

  }
}
</script>

<style scoped>

.app-container{

  background: #fff;

  margin: 15px 30px 15px 15px;

}

.box {

  position: relative;

  border-radius: 3px;

  background: #ffffff;

  border-top: 3px solid #3c8dbc;

  padding: 10px;

  margin-bottom: 20px;

  width: 100%;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

}

.filter-container{

  float: left;
  padding:10px 0 15px 0;


}
.pagiantion{

  text-align: right;

  padding: 15px;

}
.divupload{
  position: relative;
  right: 150px;
}

</style>
